<template>
  <div class="multiple-checkbox-component" v-invalid="validation.is_valid">
    <div class="field">
      <label class="label"
             v-if="field.label"
             :for="field.id">
        <strong class="has-text-grey-dark">{{ field.label }}</strong>
      </label>
      <div class="control">
        <ul v-if="field.layout.layout_type === 'vertical'">
          <li v-for="(option, key) in field.properties.options" :key="key">
            <label class="checkbox" ref="label">
              <input type="checkbox"
                     v-model="formData.fields[field.id].value"
                     @change="formData.inputOnChange(field); removeValidation()"
                     :id="option.option_value"
                     :value="option.option_value"
                     :disabled="field.properties.input_readonly">
              <span class="check"></span>
              <span class="control-label">{{ option.display_name ? option.display_name : option.option_value }}</span>
            </label>
          </li>
        </ul>

        <div v-if="field.layout.layout_type === 'horizontal'">
          <label v-for="(option, key) in field.properties.options" :key="key" class="radio" >
            <input type="checkbox"
                   v-model="formData.fields[field.id].value"
                   @change="formData.inputOnChange(option); removeValidation()"
                   :id="option.id"
                   :name="field.id"
                   :value="option.option_value"
                   :disabled="field.properties.input_readonly">
            <span class="check"></span>
            <span class="control-label">{{ option.display_name ? option.display_name : option.option_value }}</span>
          </label>
        </div>

        <p class="help is-danger"
           v-if="!validation.is_valid" v-translate>
          {{ validation.message }}
        </p>
        <p class="help"
           v-if="field.properties.help_text"
           v-html="field.properties.help_text">
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  import FormField from '@/classes/form/FormField'
  import FormData from '@/classes/form/FormData'

  export default {
    name: 'multiple-checkbox-component',
    props: {
      field: {
        type: FormField
      },
      formData: {
        type: FormData
      }
    },
    computed: {
      validation () {
        return this.formData.validations[this.field.id] || { is_valid: true }
      }
    },
    methods: {
      removeValidation () {
        this.validation.is_valid = true
      }
    }
  }
</script>

<style lang="sass" scoped>
  .label
    margin-bottom: 1em

  ul
    list-style-position: inside
    li
      margin-bottom: 1.53rem

</style>
